var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._l(_vm.options, function (item, index) {
        return [
          _vm.values.includes(item.value)
            ? [
                item.raw.listClass === "default" || item.raw.listClass === ""
                  ? _c(
                      "span",
                      {
                        key: item.value,
                        class: item.raw.cssClass,
                        attrs: { index: index },
                      },
                      [_vm._v(_vm._s(item.label) + "\n      ")]
                    )
                  : _c(
                      "el-tag",
                      {
                        key: item.value,
                        class: item.raw.cssClass,
                        attrs: {
                          "disable-transitions": true,
                          index: index,
                          type:
                            item.raw.listClass === "primary"
                              ? ""
                              : item.raw.listClass,
                        },
                      },
                      [_vm._v("\n        " + _vm._s(item.label) + "\n      ")]
                    ),
              ]
            : _vm._e(),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }